import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import EmailsWidget from '../../components/emailsWidget';
import FaqWidget from '../../components/faqWidget';
import EmailExtendedPlansWidget from '../../components/emailExtendedPlansWidget';
import EmailPlansWidget from '../../components/emailPlansWidget';
import ContactBanner from '../../components/contactBanner/ContactBanner';
import emailBannerFr from '../../assets/img/email-banner-fr.svg';
import emailBannerEn from '../../assets/img/email-banner-en.svg';
import releaseIcon from '../../assets/img/release-icon.svg';
import checkmarkIcon from '../../assets/img/checkmark.svg';
import startIcon from '../../assets/img/star-orange.svg';
import TopBanner from '../../components/topBanner';
import infoBanner1 from '../../assets/img/info-banner-1.svg';
import infoBanner2 from '../../assets/img/info-banner-2.svg';
import infoBanner3 from '../../assets/img/info-banner-3.svg';
import emailBanner1 from '../../assets/img/email-1.svg';
import emailBanner2 from '../../assets/img/email-2.svg';
import emailBanner3 from '../../assets/img/email-3.svg';
import emailBanner4 from '../../assets/img/email-4.svg';
import emailBanner5 from '../../assets/img/email-5.svg';
import emailBanner6 from '../../assets/img/email-6.svg';
import business1 from '../../assets/img/business-1.svg';
import business2 from '../../assets/img/business-2.svg';
import business3 from '../../assets/img/business-3.svg';
import business4 from '../../assets/img/business-4.svg';
import { SmoothScrollLink } from '../../utils/navUtils';
import './email.scss';

function EmailPage() {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;
    const isFR = currentLanguage === 'fr';

    const localizedPath = (path) => {
        const baseLangUrl = `/${currentLanguage}`;
        return baseLangUrl + path;
    };

    return (
        <>
            <Helmet>
                <title>{t('titles.email')}</title>
            </Helmet>
            <div className="email-page-wrapper">
                <TopBanner
                    bannerImage={
                        <img src={isFR ? emailBannerFr : emailBannerEn} alt="Email banner" />
                    }
                    className="web-top-banner"
                >
                    <>
                        <h1 className="banner-header">{t('email-page.top-banner.title')}</h1>
                        <h2
                            className="banner-sub-header"
                            dangerouslySetInnerHTML={{
                                __html: t('email-page.top-banner.text')
                            }}
                        />
                        <ul className="banner-list">
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">{t('email-page.top-banner.list-1')}</p>
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">{t('email-page.top-banner.list-2')}</p>
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">{t('email-page.top-banner.list-3')}</p>
                            </li>
                        </ul>
                        <hr className="banner-separator" />
                        <div className="banner-badges">
                            <span className="single-badge">
                                <img src={startIcon} alt="Star" />
                                {t('titles.free-domain')}
                            </span>
                        </div>
                        <div className="banner-actions">
                            <Nav>
                                <SmoothScrollLink
                                    to={localizedPath('/professional-business-email#plans-section')}
                                >
                                    <Navbar.Brand>{t('buttons.order-email')}</Navbar.Brand>
                                </SmoothScrollLink>
                            </Nav>
                            <div className="action-info">
                                <img src={checkmarkIcon} alt="Checkmark" />
                                <p className="action-text">30-Day Money-Back Guarantee</p>
                            </div>
                        </div>
                    </>
                </TopBanner>
                <section className="info-banner">
                    <Container>
                        <Row>
                            <Col lg={4}>
                                <div className="info-banner-block">
                                    <img
                                        className="info-image"
                                        src={infoBanner1}
                                        alt="Info banner"
                                    />
                                    <h3 className="info-banner-title">
                                        {t('banners.info-banner-web.col-1-text')}
                                    </h3>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="info-banner-block">
                                    <img
                                        className="info-image"
                                        src={infoBanner2}
                                        alt="Info banner"
                                    />
                                    <h3 className="info-banner-title">
                                        {t('banners.info-banner-web.col-2-text')}
                                    </h3>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="info-banner-block">
                                    <img
                                        className="info-image"
                                        src={infoBanner3}
                                        alt="Info banner"
                                    />
                                    <h3 className="info-banner-title">
                                        {t('banners.info-banner-web.col-3-text')}
                                    </h3>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section-wrapper plans-section" id="plans-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('email-page.plans-title')
                                }}
                            />
                            <p className="section-text">{t('email-page.plans-text')}</p>
                        </div>
                        <EmailPlansWidget />
                    </Container>
                </section>
                <section className="section-wrapper email-plans-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('email-page.email-plan-title')
                                }}
                            />
                            <p className="section-text">{t('email-page.email-plan-text')}</p>
                        </div>
                        <Row>
                            <Col md={4} xs={12}>
                                <div className="single-email-plan">
                                    <Row>
                                        <Col md={3}>
                                            <img
                                                className="email-image"
                                                src={emailBanner1}
                                                alt="Email"
                                            />
                                        </Col>
                                        <Col md={9}>
                                            <h3 className="email-title">
                                                {t('email-page.email-plan-column.title-1')}{' '}
                                                <span className="included">{t('titles.free')}</span>
                                            </h3>
                                            <p className="email-text">
                                                {t('email-page.email-plan-column.text-1')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={4} xs={12}>
                                <div className="single-email-plan">
                                    <Row>
                                        <Col md={3}>
                                            <img
                                                className="email-image"
                                                src={emailBanner2}
                                                alt="Email"
                                            />
                                        </Col>
                                        <Col md={9}>
                                            <h3 className="email-title">
                                                {t('email-page.email-plan-column.title-2')}
                                            </h3>
                                            <p className="email-text">
                                                {t('email-page.email-plan-column.text-2')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={4} xs={12}>
                                <div className="single-email-plan">
                                    <Row>
                                        <Col md={3}>
                                            <img
                                                className="email-image"
                                                src={emailBanner3}
                                                alt="Email"
                                            />
                                        </Col>
                                        <Col md={9}>
                                            <h3 className="email-title">
                                                {t('email-page.email-plan-column.title-3')}
                                            </h3>
                                            <p className="email-text">
                                                {t('email-page.email-plan-column.text-3')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={4} xs={12}>
                                <div className="single-email-plan">
                                    <Row>
                                        <Col md={3}>
                                            <img
                                                className="email-image"
                                                src={emailBanner4}
                                                alt="Email"
                                            />
                                        </Col>
                                        <Col md={9}>
                                            <h3 className="email-title">
                                                {t('email-page.email-plan-column.title-4')}
                                            </h3>
                                            <p className="email-text">
                                                {t('email-page.email-plan-column.text-4')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={4} xs={12}>
                                <div className="single-email-plan">
                                    <Row>
                                        <Col md={3}>
                                            <img
                                                className="email-image"
                                                src={emailBanner5}
                                                alt="Email"
                                            />
                                        </Col>
                                        <Col md={9}>
                                            <h3 className="email-title">
                                                {t('email-page.email-plan-column.title-5')}
                                            </h3>
                                            <p className="email-text">
                                                {t('email-page.email-plan-column.text-5')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col md={4} xs={12}>
                                <div className="single-email-plan">
                                    <Row>
                                        <Col md={3}>
                                            <img
                                                className="email-image"
                                                src={emailBanner6}
                                                alt="Email"
                                            />
                                        </Col>
                                        <Col md={9}>
                                            <h3 className="email-title">
                                                {t('email-page.email-plan-column.title-6')}
                                            </h3>
                                            <p className="email-text">
                                                {t('email-page.email-plan-column.text-6')}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section-wrapper business-email-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('email-page.business-email-title')
                                }}
                            />
                            <p className="section-text">{t('email-page.business-email-text')}</p>
                        </div>

                        <div className="single-business-email">
                            <Row>
                                <Col lg={6} xs={12}>
                                    <div className="image-wrapper">
                                        <img src={business1} alt="Business" />
                                    </div>
                                </Col>
                                <Col lg={6} xs={12}>
                                    <div className="business-info">
                                        <h3 className="business-title">
                                            {t('email-page.business-email-column.title-1')}
                                        </h3>
                                        <p className="business-text">
                                            {t('email-page.business-email-column.text-1')}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="single-business-email">
                            <Row>
                                <Col lg={6} xs={12} className="order-sm-last order-lg-first">
                                    <div className="business-info">
                                        <h3 className="business-title">
                                            {t('email-page.business-email-column.title-2')}
                                        </h3>
                                        <p className="business-text">
                                            {t('email-page.business-email-column.text-2')}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    lg={6}
                                    xs={12}
                                    className="order-sm-first order-lg-last text-right"
                                >
                                    <div className="image-wrapper">
                                        <img src={business2} alt="Business" />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="single-business-email">
                            <Row>
                                <Col lg={6} xs={12}>
                                    <div className="image-wrapper">
                                        <img src={business3} alt="Business" />
                                    </div>
                                </Col>
                                <Col lg={6} xs={12}>
                                    <div className="business-info">
                                        <h3 className="business-title">
                                            {t('email-page.business-email-column.title-3')}
                                        </h3>
                                        <p className="business-text">
                                            {t('email-page.business-email-column.text-3')}
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className="single-business-email">
                            <Row>
                                <Col lg={6} xs={12} className="order-sm-last order-lg-first">
                                    <div className="business-info">
                                        <h3 className="business-title">
                                            {t('email-page.business-email-column.title-4')}
                                        </h3>
                                        <p className="business-text">
                                            {t('email-page.business-email-column.text-4')}
                                        </p>
                                    </div>
                                </Col>
                                <Col
                                    lg={6}
                                    xs={12}
                                    className="order-sm-first order-lg-last text-right"
                                >
                                    <div className="image-wrapper">
                                        <img src={business4} alt="Business" />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </section>
                <section className="regular-banner p-5">
                    <h3 className="banner-title">{t('banners.regular-banner-email-text')}</h3>
                </section>
                <section className="section-wrapper emails-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('email-page.emails-title')
                                }}
                            />
                            <p className="section-text">{t('email-page.emails-text')}</p>
                        </div>
                        <EmailsWidget />
                    </Container>
                </section>
                <section className="section-wrapper extended-plans-section" id="all-plans-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('email-page.email-plans-title')
                                }}
                            />
                            <p className="section-text">{t('email-page.email-plans-text')}</p>
                        </div>
                        <EmailExtendedPlansWidget />
                    </Container>
                </section>
                <section className="section-wrapper faq-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('email-page.faq-title')
                                }}
                            />
                            <p className="section-text">{t('email-page.faq-text')}</p>
                        </div>
                        <FaqWidget dataType="email" />
                    </Container>
                </section>
                <ContactBanner />
            </div>
        </>
    );
}

export default EmailPage;
